module.exports = __webpack_public_path__ + "static/media/parking_siren_on.f495d996.svg";